if (!customElements.get('cart-upsell-button')) {
  customElements.define(
    'cart-upsell-button',
    class CartUpsellButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (this.button) {
          this.clickHandler = this.onClick.bind(this);
          this.button.addEventListener('click', this.clickHandler);
        }
      }

      disconnectedCallback() {
        if (this.button && this.clickHandler) {
          this.button.removeEventListener('click', this.clickHandler);
        }
      }

      onClick() {
        if (this.button.disabled) return;
        this.button.disabled = true;
        this.button.classList.add('loading');

        const addVariantId = this.dataset.addVariantId;
        const addQuantity = parseInt(this.dataset.addQuantity || '1', 10);
        const removeVariantId = this.dataset.removeVariantId;

        const removeFromCart = () => {
          if (!removeVariantId) return Promise.resolve();
          return fetch(routes.cart_change_url, {
            ...fetchConfig(),
            body: JSON.stringify({ id: removeVariantId, quantity: 0 }),
          });
        };

        const addToCart = () =>
          fetch(routes.cart_add_url, {
            ...fetchConfig(),
            body: JSON.stringify({ items: [{ id: addVariantId, quantity: addQuantity }] }),
          });

        removeFromCart()
          .then(addToCart)
          .then((response) => response.json())
          .then((data) => {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-upsell-button',
              cartData: data,
              variantId: addVariantId,
            });
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.button.disabled = false;
            this.button.classList.remove('loading');
          });
      }
    }
  );
}

if (!customElements.get('cart-bonus-sync')) {
  customElements.define(
    'cart-bonus-sync',
    class CartBonusSync extends HTMLElement {
      connectedCallback() {
        const bonusEntitlement = parseInt(this.dataset.bonusEntitlement || '0', 10);
        const bonusQty = parseInt(this.dataset.bonusQty || '0', 10);
        const bonusVariantId = this.dataset.bonusVariantId;

        if (bonusQty > bonusEntitlement && bonusVariantId) {
          fetch(routes.cart_change_url, {
            ...fetchConfig(),
            body: JSON.stringify({ id: bonusVariantId, quantity: bonusEntitlement }),
          })
            .then((response) => response.json())
            .then((data) => {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-bonus-sync',
                cartData: data,
                variantId: bonusVariantId,
              });
            })
            .catch((error) => console.error(error));
        }
      }
    }
  );
}
